import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import VideoPlayer from './components/VideoPlayer';
import VideoInfo from './components/VideoInfo';
import RelatedVideos from './components/RelatedVideos';
import { videos } from '@/mocks/videos';

export default function VideoPage() {
  const { id } = useParams<{ id: string }>();
  const video = videos.find((v) => v.id === id);

  if (!video) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-20 pb-20">
          <div className="w-full px-4 md:px-6 lg:px-8 flex flex-col items-center justify-center text-center min-h-[50vh]">
            <div className="w-20 h-20 flex items-center justify-center mb-4">
              <i className="ri-error-warning-line text-5xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl font-heading font-bold text-foreground-900 mb-2">视频未找到</h1>
            <p className="text-sm text-foreground-500 mb-6">该视频可能已被移除或链接无效</p>
            <Link
              to="/"
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const articleStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: video.title,
    description: video.description,
    datePublished: `${video.year}-01-01`,
    dateModified: video.updateDate,
    author: {
      '@type': 'Organization',
      name: '51影视网',
    },
    publisher: {
      '@type': 'Organization',
      name: '51影视网',
      url: 'https://www.51yingshi.com/',
    },
  };

  const breadcrumbStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.51yingshi.com/' },
      { '@type': 'ListItem', position: 2, name: video.category, item: `https://www.51yingshi.com/category/${video.category}` },
      { '@type': 'ListItem', position: 3, name: video.title },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="w-full px-4 md:px-6 lg:px-8 py-8">
          <div className="max-w-[1280px] mx-auto">
            <nav className="flex items-center gap-1.5 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <Link to={`/category/${video.category}`} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{video.category}</Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-700 font-medium truncate">{video.title}</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <article>
                  <VideoPlayer video={video} />
                  <div className="mt-6">
                    <VideoInfo video={video} />
                  </div>
                </article>
              </div>
              <div className="lg:col-span-1">
                <RelatedVideos currentId={video.id} relatedIds={video.relatedVideos} />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}